import {capitalize} from "lodash";

const parseNoteFromApi = (data, note) => {
  let parsedData = {
    ...data,
    author: note.author,
    author_id: note.author_id,
    id: note.id,
  };
  return parsedData;
}

export default parseNoteFromApi;